module.exports = __webpack_public_path__ + "static/img/miniImg1.1699f32c.png";